<template>
  <div id="visa-materials">

    <!-- 标题 -->
    <div class="visa-material-title">
      <div class="left-box">
        <div class="title">
          资料清单
        </div>

        <div class="select-online-offline" v-if="product.offline">
          <el-select v-model="isOffline" placeholder="请选择" size="small" @change="offlineChange">
            <el-option label="在线办理" :value="0"></el-option>
            <el-option label="线下办理" :value="1"></el-option>
          </el-select>
        </div>
      </div>
      <div class="handle-btn-box">
        <div class="btn" @click="sendMail">发送到邮箱</div>
        <button
          class="btn"
          @click="downloadAllMaterial"
          v-download-disabled:download_material
          v-if="shouldDownloadAllButtonShow"
        >
          下载所有模板
        </button>
        <button class="btn primary" @click="openPrint" v-download-disabled:download_material>
          下载资料清单
        </button>
      </div>
      
    </div>

    <div class="nav-box">
      <div class="nav">
        <div
          :id="`nav-item-${index}`"
          class="nav-item"
          v-for="(identityId, index) in currIdentities"
          :key="index"
          :class="{ 'active': identitySelected === index }"
          @click="changeApplicantIdentity(index)"
        >{{identities[identityId]}}</div>

        <div class="nav-bottom-bar" :style="{left: navBottomLeft + 'px'}"></div>
      </div>
      
    </div>

    <!-- 资料列表 -->
    <div class="visa-matetials-list">

      <!-- 电子资料 -->
      <div
        class="attr-list"
        v-for="attrItem in currMaterial"
        :key="attrItem.attr"
      >
        <div class="attr-list-title" :class="[`attr-list-title-${attrItem.attr}`]">
          <div class="text">{{attrItem.name}}({{attrItem.materialTotal}})</div>
          <div class="tips">
            <img class="icon-star" src="https://o.666visa.cn/static/ssqpeer/product/created-order/icon-material-star-2.png" alt="">
            为必备资料
          </div>
        </div>

        <div class="classify-list">
          <div
            class="classify-item"
            :class="[`classify-item-${attrItem.attr}-${classifyItem.catalog_id}`]"
            v-for="classifyItem in attrItem.classifyList"
            :key="classifyItem.catalog_id"
          >
            <div class="classify-header">
              <div class="classify-name">{{ classifyItem.name }}</div>
            </div>
            <div class="material-list">
              <div
                class="material-item"
                v-for="(materialItem, materialIndex) in classifyItem.materialList"
                :key="materialIndex"
              >
                <div class="material-name">
                  <div class="name-text">{{materialItem.name}}</div>
                  <img
                    v-if="materialItem.is_required"
                    class="icon-star"
                    src="https://o.666visa.cn/static/ssqpeer/product/created-order/icon-material-star-2.png"
                  >
                </div>
                <div class="material-info">
                  <div class="attention-box">{{materialItem.attention}}</div>
                </div>

                <div class="btn-box">
                  <a
                    v-if="materialItem.template"
                    @click="downloadSingleMaterial(materialItem)"
                    class="btn primary"
                  >下载模板</a>
                  <a
                    @click="showImage(materialItem.sample)"
                    v-if="materialItem.sample && materialItem.sample.length > 0"
                    class="btn"
                  >查看样例</a>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- 发送到邮箱 -->
    <send-material-by-email
      v-model="sendMailModal"
      :product="product"
      :is-offline="isOffline"
      :identity-selected-id="identitySelectedId"
    ></send-material-by-email>

    <!-- 打印资料 -->
    <visa-info-print
      v-model="showPrintModal"
      :product="product"
      :initial-identity-id="identitySelectedId"
      :initial-is-offline="isOffline"
    >
    </visa-info-print>


    <!-- 左侧锚点 -->
    <visa-materials-anchor
      :curr-material="currMaterial"
    ></visa-materials-anchor>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import sensorsdata from 'sa-sdk-javascript';

import Http from '../../../../libs/http';
import utils from '../../../../libs/utils';
import User from '../../../../libs/user';
import sendMaterialByEmail from './send-material-by-email';
import visaInfoPrint from './visa-info-print';
import { generateClassifiedMaterialList } from '../../services/material-service';
import VisaMaterialsAnchor from './visa-materials-anchor.vue';
import orderingService from '../../../../services/ordering-service';

export default {
  name: 'visa-materials',
  components: {
    visaInfoPrint,
    sendMaterialByEmail,
    VisaMaterialsAnchor,
  },
  props: {
    product: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    peer: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      isOffline: 0, // 是否是线下办理
      navBottomLeft: 0,
      identitySelected: 0, // 被选中的职业序号
      identities: ['在职人员', '自由职业者', '退休人员', '在校学生', '学龄前儿童', '通用身份'],
      isDownloading: false,
      sendMailModal: false,
      showPrintModal: false,
    };
  },
  computed: {
    // 当前支持的身份id
    currIdentities() {
      const list = [];
      // 筛选是否是线下
      const allMaterialList = this.isOffline ? this.product.offline_material : this.product.material;
      allMaterialList.forEach((item) => {
        list.push(item.identity_id);
      });
      return list;
    },
    // 被选中的职业id
    identitySelectedId() {
      return this.currIdentities[this.identitySelected];
    },
    // 当前身份的所有资料
    currMaterial() {
      return generateClassifiedMaterialList(this.product, this.identitySelectedId, this.isOffline);
    },
    // 当前赴馆资料
    currTakeMaterial() {
      return this.currMaterial.filter(item => item.attr === 2);
    },
    // 是否显示下载全部模板按钮,所有职业的所有资料都没有模板资料，则不显示
    shouldDownloadAllButtonShow() {
      // 筛选是否是线下
      const allMaterialList = this.isOffline ? this.product.offline_material : this.product.material;
      const allIdentityMaterial = [];
      allMaterialList.forEach((item) => {
        allIdentityMaterial.push(...item.material_required, ...item.material_optional);
      });
      // 添加照片
      if (this.product.visa_photo_id && !this.isOffline) {
        allIdentityMaterial.push({
          is_required: true,
          elec_name: '照片',
          attr: 0,
          sample: this.product.id_photo.sample,
          template: this.product.id_photo.template,
        });
      }
      // 添加申请表
      if (this.product.visa_application && !this.isOffline) {
        allIdentityMaterial.push({
          elec_name: '签证申请表',
          attr: 0,
          sample: this.product.visa_application.sample,
          template: this.product.visa_application.template,
        });
      }
      return allIdentityMaterial.some(item => item.template);
    },
  },
  watch: {
    product() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapMutations(['SHOW_LOGIN_BOX']),
    init() {
      // 查询该商品的线上递交的必填资料中包含【邮寄资料】（不包括赴馆）,若是则默认设置线下办理
      this.isOffline = orderingService.isIncludePaperMaterialByRequiredMaterial(this.product) ? 1 : 0;
      this.changeApplicantIdentity(0);
    },
    computedNavBottomLeft() {
      let left = 0;
      const navItemEl = document.querySelector(`#nav-item-${this.identitySelected}`);
      if (!navItemEl) return 0;
      left = navItemEl.offsetLeft + navItemEl.offsetWidth / 2 - 16;
      this.navBottomLeft = left;
    },
    sendMail() {
      if (!User.isLogin()) {
        this.SHOW_LOGIN_BOX({ from: 'productdetail_send_email' });
        return;
      }
      // todo
      this.sendMailModal = true;
    },

    // 下载单个资料
    downloadSingleMaterial(material) {
      if (!User.isLogin()) {
        this.SHOW_LOGIN_BOX({ from: 'productdetail_material_template' });
        return;
      }
      const { elec_id, paper_id, take_along_id, visa_application_id } = material;
      const params = { elec_id, paper_id, take_along_id, visa_application_id };
      if (!this.isDownloading) {
        this.isDownloading = true;
        Http.post('/sys/visa_product_template_download', params)
          .then((data) => {
            window.location.href = data.url;
            this.isDownloading = false;
          })
          .catch(() => {
            this.isDownloading = false;
            utils.msg.error('下载模板失败，请稍后重试');
          });
      }
    },

    // 下载全部资料
    downloadAllMaterial() {

      if (!User.isLogin()) {
        this.SHOW_LOGIN_BOX({ from: 'productdetail_download_material' });
        return;
      }

      if (!this.isDownloading) {
        this.isDownloading = true;
        sensorsdata.track('ElementClick', {
          page_from: '商品详情页',
          click_content: '下载所有模板',
        });

        Http.post('/peer_behavior_record_add', {
          visa_product_id: this.product.visa_product_id,
          behavior_type_id: 10011, // 下载商品资料清单/模板
        });


        Http.post('/sys/visa_product_template_download_batch', {
          visa_product_id: this.product.visa_product_id,
          offline: this.isOffline,
        })
          .then((data) => {
            window.location.href = data.url;
            this.isDownloading = false;
          })
          .catch(() => {
            this.isDownloading = false;
            utils.msg.error('下载全部模板失败，请稍后重试');
          });
      }
    },

    // 开启打印
    openPrint() {
      if (!User.isLogin()) {
        this.SHOW_LOGIN_BOX({ from: 'productdetail_print_material' });
        return;
      }

      this.showPrintModal = true;
      this.xbbRecord();
    },

    // 肖帮帮埋点
    xbbRecord() {
      if (User.isLogin()) {
        // 销帮帮记录埋点
        Http.post('/xbb_record_add', {
          record_type: 8,
          visa_product_id: this.product.visa_product_id,
        });
      }
    },

    // 切换身份 todo 切换没有按钮显示状态切换
    changeApplicantIdentity(index) {
      if (this.identitySelected !== index) {
        sensorsdata.track('RoleClick', {});
      }
      this.identitySelected = index;
      this.computedNavBottomLeft();
    },

    // 打开多图预览弹窗
    showImage(data) {
      if (!User.isLogin()) {
        this.SHOW_LOGIN_BOX({ from: 'productdetail_material_sample' });
        return;
      }

      // 后端部分接口资料样例 sample 返回的仍然是字符串，而不是数组，这里先做一个兼容处理。
      const urlList = typeof data === 'string' ? [data] : data;
      this.$viewerApi({
        images: urlList,
      });
    },
    offlineChange() {
      sensorsdata.track('LineClick', {
        click_module: 'product',
        line_result: this.isOffline ? 'offline' : 'online',
      });
      this.changeApplicantIdentity(0);
    },
  },

};
</script>

<style lang="less" scoped>
@import "../../../../assets/less/variable";

.red {
  color: #FF6464;
}

#visa-materials {
  box-shadow:0px 2px 8px 0px rgba(0,0,0,0.06);
  border-radius:2px;
  background: #fff;
  margin-top: 12px;

  .visa-material-title {
    padding: 16px 16px 10px 16px;
    display: flex;
    align-items: center;
    line-height: 1;
    justify-content: space-between;
    .left-box{
      display: flex;
      align-items: center;
      .title{
        color: #2F333D;
        font-size: 20px;
        font-weight: 600;
        margin-right: 14px;
        position: relative;
        z-index: 1;
        &::after{
          content: "";
          width:48px;
          height:6px;
          background:linear-gradient(270deg,rgba(89,159,255,0) 0%,rgba(89,159,255,1) 100%);
          opacity:0.6;
          position: absolute;
          left: 0;
          bottom: -2px;
          z-index: -1;
        }
      }
      .select-online-offline{
        width: 92px;
        font-size: 12px;
        /deep/ .el-input{
          font-size: 12px;
          color: #5F666E;
          .el-input__icon{
            width: 24px;
            color: #91999F;
            transform: translateY(-50%) rotateZ(180deg) scale(0.7);
            transform-origin: center center;
            right: 7px;
            top: 51%;
            &.is-reverse{
              transform: translateY(-50%) scale(0.7);
            }
          }
          .el-input__inner{
            padding-left: 14px;
            padding-right: 24px;
            border-radius: 2px;
            height: 32px;
          }
        }
      }
    }
    .handle-btn-box{
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      .btn{
        min-width: 92px;
        padding: 0 8px;
        height: 32px;
        border-radius: 2px;
        border: 1px solid #5e9be1;
        font-size: 12px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        color: #5e9be1;
        background: #fff;
        &.primary{
          color: #fff;
          background: #599FFF;
        }
      }
      .btn + .btn{
        margin-left: 8px;
      }
      .btn[disabled]{
        opacity: .5;
        cursor: not-allowed;
      }
    }
  }

  .nav-box{
    border-bottom: 1px solid #E9EEF2;
    display: flex;
    align-items: center;
    padding: 0 16px;
    .nav{
      flex-grow: 1;
      height: 48px;
      display: flex;
      margin-right: -32px;
      position: relative;
      .nav-item{
        display: flex;
        align-items: center;
        margin-right: 32px;
        color: #91999F;
        font-size: 14px;
        cursor: pointer;
        &.active{
          color: #599FFF;
          font-weight: 600;
        }
      }
      .nav-bottom-bar{
        position: absolute;
        left: 0;
        bottom: -1px;
        transition: 0.15s all;
        width:32px;
        height:3px;
        background:linear-gradient(90deg,rgba(31,136,255,1) 0%,rgba(138,192,255,1) 100%);
        border-radius:2px 2px 0px 0px;
      }
    }
    
  }

  .visa-matetials-list {
    padding: 20px 0 20px 0;
    width: 100%;
    color: #2F333D;
    .attr-list {
      margin-bottom: 20px;
      padding: 0 16px;
      &:last-child{
        margin-bottom: 0;
      }
      .attr-list-title {
        display: flex;
        align-items: center;
        line-height: 1;
        margin-bottom: 16px;
        position: relative;
        .text{
          color: #2F333D;
          font-size: 14px;
          font-weight: 600;
        }
        .tips{
          display: flex;
          align-items: center;
          margin-left: 8px;
          color: #5F666E;
          font-size: 14px;
          .icon-star{
            width: 12px;
            height: 11px;
            margin-right: 4px;
          }
        }
      }
      .classify-list{
        width: 100%;
        border: 1px solid #E9EEF2;
        .classify-item{
          border-bottom: 1px solid #E9EEF2;
          display: flex;
          &:last-child{
            border-bottom: none;
          }
          .classify-header{
            flex-shrink: 0;
            width: 102px;
            padding: 16px 12px ;
            border-right: 1px solid #E9EEF2;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;

            .classify-name{
              color: #5F666E;
              font-size: 14px;
              font-weight: 600;
              line-height: 20px;
            }
          }
          .material-list{
            width: 100%;
            .material-item{
              width: 100%;
              font-size: 14px;
              display: flex;
              border-bottom: 1px solid #E9EEF2;
              &:last-child{
                border-bottom: none;
              }
              .material-name{
                border-right: 1px solid #E9EEF2;
                padding: 16px;
                flex-shrink: 0;
                width: 162px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                .name-text{
                  font-size: 14px;
                  line-height: 20px;
                  color: #5F666E;
                  text-align: center;
                  word-break: break-all;
                  font-weight: 600;
                }
                .icon-star{
                  margin-top: 4px;
                  width: 12px;
                  height: 11px;
                }
              }
              .material-info{
                flex-grow: 1;
                overflow: hidden;
                padding: 16px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                border-right: 1px solid #E9EEF2;
                .attention-box{
                  line-height: 24px;
                  white-space: pre-wrap;
                  position: relative;
                  word-break: break-all;
                  color: #5F666E;
                }
              }
              .btn-box{
                padding: 16px;
                width: 112px;
                flex-shrink: 0;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                .btn {
                  font-size: 12px;
                  cursor: pointer;
                  color: #5F666E;
                  &.primary{
                    color: #599FFF;
                  }
                  &:hover{
                    opacity: 0.6;
                  }
                }
                .btn + .btn{
                  margin-top: 16px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/product/product-info/components/visa-materials.vue